// SEC-003: backend routers/orders.py _require_order_perm / _require_production_edit ile BİREBİR aynı kural
const QUOTE_STAGES = new Set(["teklif", "reddedildi"]);

export const canOrder = (can, action, order) =>
  can("orders", action) || (!!order && QUOTE_STAGES.has(order.stage) && can("quotes", action));

export const canProdEdit = (can) => can("production", "edit") || can("production", "manage");
